import { WHICH_AREAS_IMPROVE } from "../enum";

const whichAreasImproveOptions = [WHICH_AREAS_IMPROVE.FULL_BODY, WHICH_AREAS_IMPROVE.ARMS, WHICH_AREAS_IMPROVE.BELLY, WHICH_AREAS_IMPROVE.BUTT, WHICH_AREAS_IMPROVE.LEGS];

export default whichAreasImproveOptions;
